import { render, staticRenderFns } from "./Asignar.vue?vue&type=template&id=5c2a5289&"
import script from "./Asignar.vue?vue&type=script&lang=js&"
export * from "./Asignar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports